'use strict';

var Radio = require('backbone.radio');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var View = require('./item').default;

export default Marionette.CollectionView.extend({

  tagName: 'ul',
  className: 'timezone-picker',
  childView: View,
  events: {
    'click button': 'onClickItem',
  },

  initialize: function () {
    this.collection = new Backbone.Collection(window.TIMEZONES);
    this.listenTo(Radio.channel('windows'), 'close', this.close);
  },

  onClickItem: function (evt) {
    if (window.localStorage.getItem('timezone') !== null) {
      window.localStorage.setItem('previous_timezone', window.localStorage.getItem('timezone'));
    }

    window.localStorage.setItem('timezone', evt.target.dataset.timezone);
    this.triggerMethod('changeTimezone');
    Radio.channel('timezone').trigger('change');
  },

  focusFirst: function () {
    var view = this.children.first();
    view.setFocus();
  },

  close: function () {
    this.triggerMethod('closeTimezonePicker');
  },

  filter: function (child) {
    if (this.query) {
      return child.get('label').toLowerCase().indexOf(this.query) !== -1;
    }

    return true;
  },

  setQuery: function (query) {
    this.query = query.toLowerCase();

    this.render();
  },

});
